import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  auth: {},
  loading: false,
  message: "",
  error: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.USER_LOGIN_SUCCESS:
      return {
        ...state,
        auth: action.payload,
        message: "Login Successfully Completed",
        loading: false,
        error: false,
      };
    case TYPE.USER_LOGIN_FAILED:
      return {
        ...state,
        auth: {},
        message: "Login failed",
        loading: false,
        error: true,
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
